import script from "./SubscriptionDetailHeroCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionDetailHeroCard.vue?vue&type=script&setup=true&lang=ts"

import "./SubscriptionDetailHeroCard.vue?vue&type=style&index=0&id=4152bb37&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4152bb37"]])

export default __exports__